<template>
  <section class="evento-lux">

    <!-- ===== TARJETA 1: CEREMONIA RELIGIOSA ===== -->
    <article ref="card1" class="card" aria-label="Ceremonia Religiosa">
      <img class="icono render-gpu" src="@/assets/ig - copia.avif" alt="Corona" />
      <h3 class="titulo-script">Ceremonia</h3>
      <p class="hora">6:00 PM</p>
      <p class="lugar">Parroquia De Nuestra Señora De la Encarnación</p>
      <p class="direccion">
    Paseo Lomas de Rosales #616 Col. Lomas de Rosales<br>Tampico, Tamaulipas.
      </p>

      <a
        ref="btn1"
        class="btn-rosa render-gpu"
        href="https://maps.app.goo.gl/V96VHRNEQNw8A9bK7"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>

  

    <!-- ===== TARJETA 2: CELEBRACIÓN ===== -->
    <article ref="card2" class="card" aria-label="Recepción">
      <img class="icono render-gpu" src="@/assets/coroa.png" alt="Corona" />
      <h3 class="titulo-script">Recepción</h3>
      <p class="hora">8:00 PM</p>
      <p class="lugar">Salon de eventos "Reina Madre"


</p>
      <p class="direccion">
      Avenida Universidad 108, Las Americas <br>Cd Madero, Tamaulipas.
      </p>

      <a
        ref="btn2"
        class="btn-rosa render-gpu"
        href="https://maps.app.goo.gl/Ki6cj3H1F4V2sL237"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>

  </section>
</template>
<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const card1 = ref(null)
    const btn1 = ref(null)
    const card2 = ref(null)
    const btn2 = ref(null)

    let ctx = null

    const animCard = (cardEl, btnEl) => {
      if (!cardEl || !btnEl) return

      const $ = gsap.utils.selector(cardEl)
      const icono  = $('.icono')
      const titulo = $('.titulo-script')
      const hora   = $('.hora')
      const lugar  = $('.lugar')
      const dir    = $('.direccion')

      // Timeline principal
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          // Cambiado a 'top 92%' para responder mejor en pantallas pequeñas
          start: 'top 92%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out', force3D: true }
      })

      // Aumentamos ligeramente la distancia 'y' (de 30/15 a 45/25) para que el movimiento sea visible
      tl.from(cardEl, { opacity: 0, y: 45, duration: 0.7, delay: 0.15 })
        .from(icono,  { opacity: 0, scale: 0.7, duration: 0.4 }, '-=0.4')
        .from(titulo, { opacity: 0, y: 25, duration: 0.4 }, '-=0.25')
        .from(hora,   { opacity: 0, y: 20, duration: 0.3 }, '-=0.2')
        .from(lugar,  { opacity: 0, y: 20, duration: 0.3 }, '-=0.2')
        .from(dir,    { opacity: 0, y: 20, duration: 0.3 }, '-=0.2')
        .from(btnEl,  { opacity: 0, scale: 0.85, duration: 0.4 }, '-=0.15')

      // Destello del botón al revelarse
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 0.9, delay: 0.3, ease: 'power2.out' }
          )
        }
      })
    }

    onMounted(() => {
      ctx = gsap.context(() => {
        gsap.config({ force3D: true })
        animCard(card1.value, btn1.value)
        animCard(card2.value, btn2.value)

        // Forzar recalculo de posiciòn tras montar (clave para móviles)
        ScrollTrigger.refresh()
      })
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return { card1, btn1, card2, btn2 }
  }
}
</script>
<style scoped>
/* ==================== BASE ELEGANTE ==================== */
.evento-lux {
  min-height: 100%;
  padding: 20px 18px 40px;
  background: #f0c9d3;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

/* ==================== TARJETA ==================== */
.card {
  width: min(440px, 92vw);
  padding: 26px 20px 28px;
  background: #f0c9d3;
  text-align: center;
  box-sizing: border-box;
  border: none;
}
/* Icono discreto */
.icono {
  width: 160px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.05));
  opacity: 0.92;
}

/* Tipografías */
.titulo-script {
  font-family: 'CynthiaJuneJF', cursive;
  font-weight: 400;
  font-size: 60px;
  letter-spacing: 0.4px;
  margin: 4px 0 8px;

  /* Reflejo metálico dorado */
  background: linear-gradient(
    110deg,
    #a67c00 30%,
    #bf953f 45%,
    #ffffff 50%,
    #bf953f 55%,
    #a67c00 70%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.25));
  -webkit-font-smoothing: antialiased;
  display: block;
}

.hora {
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: #141414;
  margin: 0 0 6px;
}

.lugar {
  font-family: 'padres', serif;
  font-size: 20px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: 0.1em;
  line-height: 1.3;
}

.direccion {
  font-family: 'padres', serif;
  font-style: italic;
  color: #5a5858;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto 18px;
  max-width: 90%;
}

/* ==================== BOTÓN DORADO ==================== */
.btn-rosa {
  display: inline-flex !important;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 14px;

  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f;

  color: #1a1a1a !important;
  -webkit-text-fill-color: #1a1a1a !important;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1px;

  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.5);
  border: 1px solid #8a6d3b;
  cursor: pointer;
  z-index: 5;
  overflow: hidden;
}

/* Destello Mágico */
.btn-rosa .sheen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  pointer-events: none;
}

/* ==================== LÍNEA DIVISORA ==================== */
.linea-wrapper {
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0;
}

.linea {
  width: 1px;
  height: 100%;
  background: linear-gradient(to bottom, transparent, #8a6d3b, transparent);
}

/* Aceleración por Hardware */
.render-gpu {
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px) {
  .titulo-script { font-size: 48px; }
  .hora { font-size: 20px; }
  .lugar { font-size: 17px; }
}

@media (prefers-reduced-motion: reduce) {
  * { transition: none !important; animation: none !important; }
}
</style>